import React, { Component } from 'react'
import { AddNewCallTheme } from 'modules/theme'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { globalStateSelector } from 'store/selector';
import { globalAction, callAction, messageAction } from 'store/action';
export class AddNewCall extends Component {
  constructor(props){
    super(props);
    this.callTransfer = this.callTransfer.bind(this);
    this.callMerge = this.callMerge.bind(this);
    this.callCancel = this.callCancel.bind(this);
  }
  callTransfer( data ) {
    const { callInfo, callProcess, transferInfo } = this.props
    callProcess('callTransferAgent', {
      sessionId: callInfo.sessionId,
      callId: callInfo.agentId,
      callId2: callInfo.custId,
      transferInfo: transferInfo,
    });
    this.sendMessage({
      type: 'livemonitor',
      subType: 'unsubscribe'
    });
  }

  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  callMerge( data ) {
    const { callInfo, callProcess, transferInfo, dynamicUpdate } = this.props
    callProcess('callTransferAgentMerge', {
      sessionId: callInfo.sessionId,
      callId: callInfo.agentId,
      callId2: callInfo.custId,
      transferInfo: transferInfo,
    });
    this.sendMessage({
      type: 'livemonitor',
      subType: 'unsubscribe'
    });
    // dynamicUpdate({ key: 'callTab', value: "call" });
  }
  callCancel( data ) {
    const { callInfo, callProcess, transferInfo, dynamicUpdate } = this.props
    callProcess('callTransferAgentCancel', {
      sessionId: callInfo.sessionId,
      callId: callInfo.agentId,
      callId2: callInfo.custId,
      transferInfo: transferInfo,
    });
    // dynamicUpdate({ key: 'callTab', value: "TRANSFER_LIST" });
  }
  render() {
    let { transferInfo } = this.props
    transferInfo = transferInfo || {};
    return (
      <AddNewCallTheme 
        userImg={'images/Profile.png'}
        agentName={transferInfo.name || ""}
        number={transferInfo.info || "" }
        onClickBtnTransfer={ this.callTransfer }
        btnTransfer={'images/transfer.svg'}
        onClickBtnMerge={ this.callMerge }
        btnMerge={'images/marge.svg'}
        onClickBtnCancel={ this.callCancel }
        btnCancel={'images/cancel.svg'}
        textTransfer={'Transfer'}
        textMerge={'Merge'}
        textCancel={'Cancel'}
      />
    )
  }
}

AddNewCall.propTypes = {
};

AddNewCall.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  callInfo: globalStateSelector.getInfo(state),
  transferInfo: globalStateSelector.getDynamic(state, { key: 'transferInfo' })
});

const dispatchToProps = dispatch => ({
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  }
});
export default connect(stateToProps, dispatchToProps)(AddNewCall);



// WEBPACK FOOTER //
// src/dialpad/components/layout/AddNewCall.js